var exports = {
  "Qs": "KeyboardModeIntroModal.module__content___NVVuNz",
  "h_": "KeyboardModeIntroModal.module__description___NVVuNz",
  "Xq": "KeyboardModeIntroModal.module__tips___NVVuNz",
  "uN": "KeyboardModeIntroModal.module__tip___NVVuNz",
  "HP": "KeyboardModeIntroModal.module__keys___NVVuNz",
  "eS": "KeyboardModeIntroModal.module__kbd___NVVuNz",
  "me": "KeyboardModeIntroModal.module__separator___NVVuNz",
  "xY": "KeyboardModeIntroModal.module__tipText___NVVuNz",
};

module.exports = exports;
